import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import hrmMessages from '@/modules/hrm/hrmMessages';

const formatDuration = value => {
  if (value === null || value === undefined || value === 0) return '0m';
  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  if (hours > 0 && minutes > 0) return `${hours}h${minutes}m`;
  if (hours > 0) return `${hours}h`;
  return `${minutes}m`;
};

class ExecutionDurationInput extends Component {
  state = {
    hours: 0,
    minutes: 0,
  };

  startEditing = () => {
    const { defaultValue, onChange } = this.props;
    const initial = defaultValue || 0;
    this.setState({
      hours: Math.floor(initial / 60),
      minutes: initial % 60,
    });
    onChange(initial);
  };

  clearValue = () => {
    const { onChange } = this.props;
    onChange(null);
  };

  hoursChanged = e => {
    const { onChange } = this.props;
    const { minutes } = this.state;
    const hours = Math.max(0, parseInt(e.target.value, 10) || 0);
    this.setState({ hours });
    onChange(hours * 60 + minutes);
  };

  minutesChanged = e => {
    const { onChange } = this.props;
    const { hours } = this.state;
    const minutes = Math.max(0, Math.min(59, parseInt(e.target.value, 10) || 0));
    this.setState({ minutes });
    onChange(hours * 60 + minutes);
  };

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (prevProps.value !== value && value !== null && value !== undefined) {
      this.setState({
        hours: Math.floor(value / 60),
        minutes: value % 60,
      });
    }
  }

  render() {
    const { value, defaultValue, disabled, intl } = this.props;
    const { hours, minutes } = this.state;
    const isEditing = value !== null && value !== undefined;

    if (!isEditing) {
      return (
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            if (!disabled) this.startEditing();
          }}
          style={{ whiteSpace: 'nowrap' }}
        >
          <span className="glyphicon glyphicon-pencil editable" /> ({intl.formatMessage(hrmMessages.Default)}{' '}
          {formatDuration(defaultValue)})
        </a>
      );
    }

    return (
      <div className="input-group input-group-sm" style={{ width: '160px' }}>
        <input
          type="number"
          min="0"
          className="form-control"
          style={{ width: '40px' }}
          value={hours}
          disabled={disabled}
          onChange={this.hoursChanged}
        />
        <span
          className="input-group-addon"
          style={{ cursor: 'default', padding: 0, width: '25px' }}
        >
          h
        </span>
        <input
          type="number"
          min="0"
          max="59"
          className="form-control"
          style={{ width: '40px' }}
          value={minutes}
          disabled={disabled}
          onChange={this.minutesChanged}
        />
        <div
          className="input-group-addon"
          style={{ padding: 0, width: '25px', cursor: 'pointer' }}
          onClick={this.clearValue}
        >
          <span className="fa fa-times" />
        </div>
      </div>
    );
  }
}

ExecutionDurationInput.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.number,
  defaultValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ExecutionDurationInput.defaultProps = {
  value: null,
  defaultValue: null,
  disabled: false,
};

export default injectIntl(ExecutionDurationInput);
